import React, { useState } from 'react';
import style from '@/styles/pages/Metrics.module.css';
import { flexRender } from '@tanstack/react-table';
import { toggleAdmin } from 'rest/makeSurveyClient';

const UserDataTableRow = ({
  row,
  cell,
  onDataChange,
}: {
  cell: any;
  row: any;
  onDataChange: any;
}) => {
  const [toggleButton, setToggleButton] = useState<boolean>(
    cell.getContext().getValue()
  );

  const handleToggleChange = async (row: any, newValue: any) => {
    const status = await toggleAdmin(row.original.id, newValue);
    if (status === 'ok') setToggleButton(newValue);
    onDataChange();
  };

  return (
    <td key={cell.id} className={style.td}>
      {cell.column.columnDef.header === 'Admin' ? (
        <input
          className={style.switch}
          type="checkbox"
          checked={toggleButton}
          onChange={() =>
            handleToggleChange(row, !cell.getContext().getValue())
          }
        />
      ) : (
        flexRender(cell.column.columnDef.cell, cell.getContext())
      )}
    </td>
  );
};

export default UserDataTableRow;
